module.exports = __webpack_public_path__ + "static/media/F9.e221e950.png";